const SLIDER = {
  SET_SLIDER_QUERY: 'SET_SLIDER_QUERY',
};

export default SLIDER;
